import React from 'react';
import { useAtomValue } from 'jotai';
import { Drawer } from '../../../../common/multi-level-drawer';
import { TASK_MODE } from '../../../../common/task-state/constants';
import { SidePanel } from '../../../../modernization-common/side-panel-m4/side-panel';
import { taskModeAtom } from '../../atoms/task-mode-atoms';
import { ReviewSidePanel } from '../side-panel/review-side-panel';
import { useDrawerManager } from './hooks/use-drawer-manager';
export function SidePanelContent() {
  const taskMode = useAtomValue(taskModeAtom);
  useDrawerManager();
  return <>
      {taskMode === TASK_MODE.EDIT && <SidePanel />}
      {taskMode === TASK_MODE.REVIEW && <ReviewSidePanel />}

      <Drawer />
    </>;
}